import React, { ChangeEvent, forwardRef, KeyboardEventHandler } from 'react';

import { IconButton, TextField } from '@mui/material';
import clsx from 'clsx';

import { ClearIcon } from 'components/common/Icons/Icons';

import styles from './InputSearch.module.scss';

interface InputSearchProps {
  placeholder: string;
  onSearch: (value: string) => void;
  className?: string;
  onBlur?: () => void;
  onFocus?: () => void;
  onKeyDown?: KeyboardEventHandler<HTMLDivElement> | undefined;
  isLoading?: boolean;
  onClear?: () => void;
}

const InputSearch = forwardRef(
  (
    { placeholder, className, onFocus, onBlur, onSearch, onKeyDown, isLoading = false, onClear }: InputSearchProps,
    ref,
  ) => {
    const [inputValue, setInputValue] = React.useState('');

    const handleOnInputChange = (event: ChangeEvent<HTMLInputElement>) => {
      setInputValue(event.target.value);
      onSearch(event.target.value);
    };

    return (
      <TextField
        inputRef={ref}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={handleOnInputChange}
        onKeyDown={onKeyDown}
        value={inputValue}
        fullWidth
        classes={{ root: styles.textFieldRoot }}
        className={className}
        placeholder={placeholder}
        variant="outlined"
        InputProps={{
          endAdornment: (
            <>
              {!isLoading && inputValue && (
                <IconButton
                  classes={{ root: styles.iconButton }}
                  onClick={() => {
                    if (onClear) {
                      onClear();
                    }

                    setInputValue('');
                  }}
                >
                  <ClearIcon className={styles.clearIcon} />
                </IconButton>
              )}
              {isLoading && <div className={styles.loader} />}
            </>
          ),
          classes: { root: clsx(styles.inputRoot, className), input: styles.input, focused: styles.inputFocused },
        }}
      />
    );
  },
);

export default InputSearch;
